<div #goUp [class]="!isMobile ? 'booble-backdrop-drawer-right' : ''">
  <div class="overflow-modal" [class]="!isMobile ? 'drawer-rtl-in' : ''">
    <ng-container *ngIf="boobleModalData == '0'">
      <div [class]="!isMobile ? 'drawer-content-lg' : ''">
        <div
          [class]="!isMobile ? 'drawer-header padding-left-32' : ''"
          class="row"
        >
          <div class="col-md-11">
            <div class="d-flex flex-column">
              <div class="row gap-22 mobile-row mg-top-32">
                <div
                  class="col-md col col-xs-4"
                  [ngClass]="{
                    'border-blue': step >= 1,
                    'border-grey': step < 1
                  }"
                ></div>

                <div
                  class="col-md col col-xs-4"
                  [ngClass]="{
                    'border-blue': step >= 2,
                    'border-grey': step < 2
                  }"
                ></div>

                <div
                  class="col-md col col-xs-4"
                  [ngClass]="{
                    'border-blue': step >= 3,
                    'border-grey': step < 3
                  }"
                ></div>
              </div>

              <div
                [class]="
                  isMobile ? 'justify-content-between' : 'justify-content-end'
                "
                class="row d-flex mt-3 mb-4"
              >
                <ng-container *ngIf="isMobile">
                  <img
                    (click)="step === 1 ? closeModal() : goBackHandler()"
                    src="assets/icons/arrow-drawer.svg"
                  />
                </ng-container>
                <p>Passo {{ step }} de 3</p>
              </div>

              <h2 class="title-modal">Receber dinheiro do exterior</h2>
              <p
                [class]="isMobile ? '' : 'mg-bottom-24'"
                class="p-text-grey-scale-dark"
              >
                Selecione ou preencha as informações para receber dinheiro do
                exterior.
              </p>
            </div>
          </div>

          <div
            *ngIf="!isMobile"
            class="col-md-1 d-flex justify-content-end mg-top-10"
          >
            <div (click)="closeModal()" class="close-icon tappable">
              <img src="assets/image/close-modal-icon.svg" />
            </div>
          </div>
        </div>
        <div
          class="mt-4"
          [class]="!isMobile ? 'modal-dialog-scrollable-general' : ''"
        >
          <div [class]="!isMobile ? 'modal-body' : ''" class="h-100">
            <app-currency-selection
              *ngIf="step === 1"
              [warrenGlobalOnly]="warrenGlobalOnly"
              (currencySelected)="currencySelectedHandler($event)"
            >
            </app-currency-selection>
            <app-sender-selection
              class="component"
              (goBack)="goBackHandler()"
              (closeModal)="closeModal()"
              [currency]="currency"
              [country]="country"
              [warrenGlobalOnly]="warrenGlobalOnly"
              (countrySave)="countryHandler($event)"
              [data]="createOrderInboundModel"
              [loading]="loading"
              *ngIf="step === 2"
              (senderSave)="senderSaveHandler($event)"
            >
            </app-sender-selection>
            <app-confirm-info
              class="component"
              (goBack)="goBackHandler()"
              (closeModal)="closeModal()"
              (saveOrder)="createOrderInbound()"
              [orderDetails]="createOrderInboundModel"
              [loading]="loading"
              [currency]="currency"
              *ngIf="step === 3"
            >
            </app-confirm-info>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="boobleModalData == '1'">
      <div [class]="!isMobile ? 'drawer-content-lg' : ''">
        <div
          [class]="!isMobile ? 'drawer-header padding-left-32' : ''"
          class="row"
        >
          <div class="col-md-11">
            <div class="d-flex flex-column">
              <div class="row gap-22 mobile-row mg-top-32">
                <div
                  class="col-md col col-xs-4"
                  [ngClass]="{
                    'border-blue': step >= 1,
                    'border-grey': step < 1
                  }"
                ></div>

                <div
                  class="col-md col col-xs-4"
                  [ngClass]="{
                    'border-blue': step >= 2,
                    'border-grey': step < 2
                  }"
                ></div>

                <div
                  *ngIf="hasDocumentStep"
                  class="col-md col col-xs-4"
                  [ngClass]="{
                    'border-blue': step >= 3,
                    'border-grey': step < 3
                  }"
                ></div>
              </div>

              <div
                [class]="
                  isMobile ? 'justify-content-between' : 'justify-content-end'
                "
                class="row d-flex mt-3 mb-4"
              >
                <ng-container *ngIf="isMobile">
                  <img
                    (click)="step === 1 ? closeModal() : goBackHandler()"
                    src="assets/icons/arrow-drawer.svg"
                  />
                </ng-container>
                <p>Passo {{ step }} de {{ hasDocumentStep ? 3 : 2 }}</p>
              </div>

              <h2 class="title-modal">Envio de dinheiro para o exterior</h2>
              <p
                [class]="isMobile ? '' : 'mg-bottom-24'"
                class="p-text-grey-scale-dark"
              >
                Selecione ou preencha as informações necessárias para realizar
                um envio para o exterior
              </p>
            </div>
          </div>

          <div
            *ngIf="!isMobile"
            class="col-md-1 d-flex justify-content-end mg-top-10"
          >
            <div (click)="closeModal()" class="close-icon tappable">
              <img src="assets/image/close-modal-icon.svg" />
            </div>
          </div>
        </div>
        <div
          class="mt-4"
          [class]="!isMobile ? 'modal-dialog-scrollable-general' : ''"
        >
          <div [class]="!isMobile ? 'modal-body' : ''" class="h-100">
            <app-finality-selection
              *ngIf="step === 1"
              [rType]="1"
              [warrenGlobalOnly]="warrenGlobalOnly"
              (finalitySelected)="finalitySelectedHandler($event)"
            >
            </app-finality-selection>
            <app-beneficiary-selection
              class="component"
              (goBack)="goBackHandler()"
              (closeModal)="closeModal()"
              [data]="createOrderModel"
              [loading]="loading"
              [finality]="finality"
              [warrenGlobalOnly]="warrenGlobalOnly"
              [okText]="hasDocumentStep ? 'Continuar' : 'Finalizar'"
              *ngIf="step === 2"
              (beneficiarySave)="beneficiarySaveHandler($event)"
            >
            </app-beneficiary-selection>
            <app-documents-order
              *ngIf="step === 3"
              (goBack)="goBackHandler()"
              [data]="createOrderModel"
              [loading]="loading"
              [finality]="finality"
              class="component"
              (sendFile)="sendFileHandler($event)"
            ></app-documents-order>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
